export default "__VITE_ASSET__m9Ej2_SL__"